// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__1NL0E","bigColWidth":"Table_bigColWidth__1eUmb","biggerColWidth":"Table_biggerColWidth__2tEUj","row":"Table_row__sFu0J","col":"Table_col__2ZQoz"};